import './index.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n.ts';

const root = ReactDOM.createRoot(document.querySelector('#root'));

root.render(<App />);
